import {env, IENVIRONMENT} from "../services/env.service";

export function getAndroidAppStoreUrl() {
        switch(env.ENVIRONMENT) {
            case IENVIRONMENT.QA:
                return `https://appcenter.tab-qa.com/apps/thrive-test-android/`;
            case IENVIRONMENT.PRODUCTION:
                return "https://play.google.com/store/apps/details?id=com.thriveapp.thriveapp";
            case IENVIRONMENT.FEATURE:
                return `https://appcenter.${env.FEATURENAME!}.tab-feature.com/apps/tf-${env.FEATURENAME!}-android/`
            default:
                return "##AndroidStoreUrl##"

        }
}

export function getIOSAppStoreUrl() {
    switch(env.ENVIRONMENT) {
        case IENVIRONMENT.QA:
            return `https://appcenter.tab-qa.com/apps/thrive-test-ios/`;
        case IENVIRONMENT.PRODUCTION:
            return "https://apps.apple.com/gb/app/thrive-app/id1513335003";
        case IENVIRONMENT.FEATURE:
            return `https://appcenter.${env.FEATURENAME!}.tab-feature.com/apps/tf-${env.FEATURENAME!}-ios/`
        default:
            return "##AppStoreUrl##";

    }

}